import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Strapi Case Study | Canny';
const Description =
  'Read about how Strapi uses Canny to interact with their community and close more deals.';
const Image = 'https://canny.io/images/14a0259aa60a5452d577c7f13806436b.jpg';
const StrapiUrl = 'https://canny.io/case-studies/strapi';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${StrapiUrl}#webpage`,
    url: StrapiUrl,
    name: 'Case Study: Strapi × Canny',
    description: 'How Strapi uses Canny to interact with their community and close more deals.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${StrapiUrl}#article`,
    genre: 'Case Study',
    headline: 'How Strapi uses Canny to interact with their community and close more deals',
    description:
      'Strapi needed a feedback tool that allowed their community to interact with each other and share feature requests. After adopting Canny—with Slack, Discord, and GitHub integrations—they doubled interaction volume, improved customer satisfaction, and even started closing more deals thanks to increased visibility.',
    inLanguage: 'en',
    url: StrapiUrl,
    mainEntityOfPage: { '@id': `${StrapiUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Strapi', url: 'https://strapi.io' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Strapi', item: StrapiUrl },
  ]),
]);

export default class StrapiLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },
          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: StrapiUrl },
          { property: 'og:type', content: 'website' },
          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
